import { focusOnBurgerButton } from "../../../services/focus";
import animationManager from "../../../services/animation-manager";
import {
  AnimationSequences,
  AnimationSequencesType,
} from "@phn/utility/constants";
import * as router from "../../../services/routing-manager";
import { navStateStore } from "@phn/state/nav-state-store";

export const handleAnimationRouting = (): AnimationRouting => {
  const actions: Record<Operations, () => AnimationRouting> = {
    OPENING: openingAction,
    CLOSING: closingAction,
    FORWARD: forwardAction,
    BACKWARDS: backwardAction,
    UNCHANGED: unchangedAction,
  };

  const conditionToExecute = getRouteAction();

  return actions[conditionToExecute]();
};

type Operations = "OPENING" | "CLOSING" | "FORWARD" | "BACKWARDS" | "UNCHANGED";
export function getRouteAction(): Operations {
  if (router.isOpening()) {
    return "OPENING";
  }
  if (router.isClosing()) {
    return "CLOSING";
  }
  if (router.isAnimatingForward()) {
    return "FORWARD";
  }
  if (router.isAnimatingBackward()) {
    return "BACKWARDS";
  }

  return "UNCHANGED";
}

interface AnimationRouting {
  nextRoute: string;
  currentRoute: string;
}

const openingAction = (): AnimationRouting => {
  animationManager.play(AnimationSequences.OPEN_SINGLE_DRAWER);

  return {
    nextRoute: "",
    currentRoute: router.getCurrentRoute(),
  };
};

const closingAction = (): AnimationRouting => {
  animationManager.play(AnimationSequences.CLOSE_SINGLE_DRAWER).then(() => {
    /* istanbul ignore if */
    if (navStateStore.state.usingKeyboard) {
      focusOnBurgerButton();
    }
  });

  return {
    nextRoute: router.getCurrentRoute() || "",
    currentRoute: router.getAnimatedRoute() || "",
  };
};

const forwardAction = (): AnimationRouting => {
  setTimeout(() => {
    animationManager
      .play(AnimationSequences.TRANSITION_NEXT_LEVEL_SINGLE_DRAWER)
      .then(() => {
        window.dispatchEvent(new CustomEvent("finishedAnimation"));
      });
  });

  return {
    nextRoute: router.getCurrentRoute() ?? "",
    currentRoute: router.getAnimatedRoute() ?? "",
  };
};

const backwardAction = (): AnimationRouting => {
  if (router.getCurrentRoute() !== "") {
    setTimeout(() => {
      animationManager
        .play(AnimationSequences.TRANSITION_PREVIOUS_LEVEL_SINGLE_DRAWER)
        .then(() => {
          router.pop();
        });
    });
  }

  return {
    nextRoute: router.getAnimatedRoute() ?? "",
    currentRoute: router.getCurrentRoute() ?? "",
  };
};

const unchangedAction = (): AnimationRouting => {
  /* istanbul ignore if */
  if (router.isResized()) {
    animationManager.play(AnimationSequences.OPEN_SINGLE_DRAWER);
  }
  return {
    nextRoute: "",
    currentRoute: router.getCurrentRoute(),
  };
};

/* istanbul ignore next */
export const isPlayingSingleDrawerAnimation = (): boolean => {
  try {
    const singleDrawerAnimationSequences: AnimationSequencesType[] = [
      AnimationSequences.OPEN_SINGLE_DRAWER,
      AnimationSequences.CLOSE_SINGLE_DRAWER,
      AnimationSequences.TRANSITION_NEXT_LEVEL_SINGLE_DRAWER,
      AnimationSequences.TRANSITION_PREVIOUS_LEVEL_SINGLE_DRAWER,
    ];

    return singleDrawerAnimationSequences.some((sequence) => {
      try {
        return animationManager.isPlaying(sequence);
      } catch {
        return false;
      }
    });
  } catch (e) {
    return false;
  }
};
